exports.IDS = {
  // IMG_URL: "http://127.0.0.1:1515",
  IMG_URL: "https://progulfshelvingnode.profcymadev.com:2427",
  // IMG_URL: "https://node.nutricos.in",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
